(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shadow-cart-drawer"]) return;
  try {
    
  if (!customElements.get('shadow-cart-drawer')) {
    customElements.define('shadow-cart-drawer', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.dialog = this.querySelector('dialog');
        this.items = this.querySelector('[data-cart-items]');
        this.status = this.querySelector('[data-cart-status]');
        this.errorBox = this.querySelector('[data-cart-error]');
        this.fallback = this.querySelector('[data-cart-fallback]');
        this.busy = false;
        this.needsCartReview = false;
        this.base = window.Shopify?.routes?.root || '/';
        this.cartUrl = this.dataset.cartUrl || this.base + 'cart';
        this.currency = this.dataset.currency;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.querySelectorAll('[data-cart-close]').forEach(button => button.addEventListener('click', () => this.close(), { signal }));
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const bounds = this.dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.close();
        }, { signal });
        this.dialog.addEventListener('close', () => {
          document.body.style.overflow = this.previousOverflow || '';
          document.dispatchEvent(new CustomEvent('shadow:cart-state', { detail: { open: false } }));
          if (this.returnFocus?.isConnected) this.returnFocus.focus({ preventScroll: true });
        }, { signal });
        document.addEventListener('click', event => {
          const trigger = event.target.closest('[data-shadow-cart-open]');
          if (!trigger || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          if (document.querySelector('.shadow-cart-page')) {
            event.preventDefault();
            window.location.assign(this.cartUrl);
            return;
          }
          event.preventDefault();
          this.open(trigger).catch(error => {
            this.show(trigger);
            this.showError(error.message);
          });
        }, { signal });
        this.querySelector('form').addEventListener('submit', event => {
          if (this.busy || this.needsCartReview) event.preventDefault();
        }, { signal });
        this.api = { add: (items, trigger) => this.add(items, trigger), open: trigger => this.open(trigger) };
        window.ShadowCart = this.api;
        document.dispatchEvent(new CustomEvent('shadow:cart-ready'));
      }

      disconnectedCallback() {
        this.controller?.abort();
        if (this.dialog?.open) {
          document.body.style.overflow = this.previousOverflow || '';
          document.dispatchEvent(new CustomEvent('shadow:cart-state', { detail: { open: false } }));
        }
        if (window.ShadowCart === this.api) delete window.ShadowCart;
        this.initialized = false;
      }

      element(tag, className, text) {
        const element = document.createElement(tag);
        if (className) element.className = className;
        if (text !== undefined) element.textContent = text;
        return element;
      }

      safeUrl(value, image = false) {
        if (typeof value !== 'string' || !value.trim()) return image ? '' : this.base;
        try {
          const url = new URL(value, location.origin);
          if (!['http:', 'https:'].includes(url.protocol)) return image ? '' : this.base;
          if (!image && url.origin !== location.origin) return this.base;
          return url.href;
        } catch { return image ? '' : this.base; }
      }

      money(cents) {
        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: this.currency }).format(Number(cents) / 100);
        } catch {
          return (Number(cents) / 100).toFixed(2) + ' ' + (this.currency || '');
        }
      }

      async request(path, body) {
        let response;
        try {
          response = await fetch(this.base + path, {
            method: body ? 'POST' : 'GET',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            credentials: 'same-origin',
            cache: 'no-store',
            ...(body ? { body: JSON.stringify(body) } : {})
          });
        } catch {
          const error = new Error(body ? this.dataset.uncertain : this.dataset.error);
          error.uncertain = Boolean(body);
          throw error;
        }
        let data;
        try { data = await response.json(); }
        catch {
          const error = new Error(body ? this.dataset.uncertain : this.dataset.error);
          error.uncertain = Boolean(body);
          throw error;
        }
        if (!data || typeof data !== 'object') {
          const error = new Error(body ? this.dataset.uncertain : this.dataset.error);
          error.uncertain = Boolean(body);
          throw error;
        }
        if (!response.ok || data.status >= 400) {
          const message = typeof data.description === 'string' ? data.description : typeof data.message === 'string' ? data.message : this.dataset.error;
          const error = new Error(message);
          error.uncertain = Boolean(body && response.status >= 500);
          throw error;
        }
        return data;
      }

      setBusy(value) {
        this.busy = value;
        this.dialog.setAttribute('aria-busy', String(value));
        this.querySelectorAll('[data-cart-mutation], [data-cart-checkout]').forEach(button => { button.disabled = value || this.needsCartReview; });
        this.status.textContent = value ? this.dataset.loading : '';
      }

      clearError() {
        this.errorBox.hidden = true;
        this.errorBox.textContent = '';
        this.fallback.hidden = true;
      }

      showError(message) {
        this.errorBox.textContent = message || this.dataset.error;
        this.errorBox.hidden = false;
        this.fallback.hidden = false;
      }

      show(trigger) {
        if (this.dialog.open) return;
        this.returnFocus = trigger || document.activeElement;
        this.previousOverflow = document.body.style.overflow;
        this.dialog.showModal();
        document.body.style.overflow = 'hidden';
        document.dispatchEvent(new CustomEvent('shadow:cart-state', { detail: { open: true } }));
      }

      close() { this.dialog.close(); }

      async open(trigger) {
        if (this.busy) { this.show(trigger); return; }
        this.clearError();
        this.setBusy(true);
        try {
          const cart = await this.request('cart.js');
          this.needsCartReview = false;
          this.render(cart);
          this.show(trigger);
          return cart;
        } finally { this.setBusy(false); }
      }

      async add(items, trigger) {
        if (this.busy) throw new Error(this.dataset.busy);
        if (this.needsCartReview) {
          this.show(trigger);
          this.showError(this.dataset.uncertain);
          throw new Error(this.dataset.uncertain);
        }
        if (!Array.isArray(items) || items.length === 0 || items.some(item => !item.id || !Number.isInteger(item.quantity) || item.quantity < 1)) throw new Error(this.dataset.error);
        this.clearError();
        this.setBusy(true);
        let added = false;
        try {
          await this.request('cart/add.js', { items });
          added = true;
          const cart = await this.request('cart.js');
          this.render(cart);
          this.show(trigger);
          return cart;
        } catch (error) {
          if (added) {
            this.needsCartReview = true;
            window.location.assign(this.cartUrl);
            return { redirected: true };
          }
          if (error.uncertain) {
            this.needsCartReview = true;
            this.show(trigger);
            this.showError(this.dataset.uncertain);
          } else {
            try {
              const cart = await this.request('cart.js');
              this.render(cart);
              this.show(trigger);
              this.showError(error.message);
            } catch {
              this.needsCartReview = true;
              this.show(trigger);
              this.showError(error.message + ' ' + this.dataset.uncertain);
            }
          }
          throw error;
        } finally { this.setBusy(false); }
      }

      async change(key, quantity, focusIndex, focusAction) {
        if (this.busy || this.needsCartReview) return;
        this.clearError();
        this.setBusy(true);
        try {
          const cart = await this.request('cart/change.js', { id: key, quantity });
          this.render(cart);
          this.status.textContent = this.dataset.updated;
          const line = this.items.children[Math.min(focusIndex, this.items.children.length - 1)];
          const target = line?.querySelector('[data-cart-action="' + focusAction + '"]') || this.querySelector('[data-cart-close]');
          requestAnimationFrame(() => target.focus({ preventScroll: true }));
        } catch (error) {
          if (error.uncertain) this.needsCartReview = true;
          this.showError(error.message);
        } finally {
          this.setBusy(false);
          if (!this.errorBox.hidden) this.status.textContent = '';
          else this.status.textContent = this.dataset.updated;
        }
      }

      render(cart) {
        if (!Array.isArray(cart.items)) throw new Error(this.dataset.error);
        this.currency = cart.currency || this.currency;
        this.items.replaceChildren();
        cart.items.forEach((item, index) => {
          const row = this.element('li', 'shadow-cart__item');
          const picture = this.element('a', 'shadow-cart__image');
          picture.href = this.safeUrl(item.url);
          picture.tabIndex = -1;
          picture.setAttribute('aria-hidden', 'true');
          const source = this.safeUrl(item.featured_image?.url || item.image, true);
          if (source) {
            const image = this.element('img');
            image.src = source;
            image.alt = '';
            image.width = 192;
            image.height = 192;
            image.loading = 'lazy';
            picture.append(image);
          }
          const content = this.element('div', 'shadow-cart__item-content');
          const title = this.element('a', 'shadow-cart__item-title', item.product_title || item.title);
          title.href = this.safeUrl(item.url);
          content.append(title);
          if (!item.product_has_only_default_variant && item.variant_title) content.append(this.element('p', 'shadow-cart__variant', item.variant_title));
          Object.entries(item.properties || {}).forEach(([key, value]) => {
            if (key.startsWith('_') || value === null || value === '') return;
            const label = key === 'Size' ? this.dataset.sizeLabel : key;
            content.append(this.element('p', 'shadow-cart__variant', label + ': ' + String(value)));
          });
          const prices = this.element('p', 'shadow-cart__prices');
          if (item.original_line_price > item.final_line_price) {
            const original = this.element('s', '', this.money(item.original_line_price));
            original.setAttribute('aria-label', this.dataset.originalPrice + ': ' + this.money(item.original_line_price));
            prices.append(original);
          }
          const current = this.element('span', '', this.money(item.final_line_price));
          current.setAttribute('aria-label', this.dataset.currentPrice + ': ' + this.money(item.final_line_price));
          prices.append(current);
          content.append(prices);
          (item.line_level_discount_allocations || []).forEach(discount => {
            if (discount.amount > 0) content.append(this.element('p', 'shadow-cart__line-discount', (discount.discount_application?.title || '') + ' −' + this.money(discount.amount)));
          });
          const controls = this.element('div', 'shadow-cart__controls');
          const quantity = this.element('div', 'shadow-cart__quantity');
          quantity.setAttribute('role', 'group');
          quantity.setAttribute('aria-label', this.dataset.quantity + ': ' + (item.product_title || item.title));
          const decrease = this.element('button', '', '−');
          decrease.type = 'button';
          decrease.dataset.cartMutation = '';
          decrease.dataset.cartAction = 'decrease';
          decrease.setAttribute('aria-label', this.dataset.decrease);
          decrease.addEventListener('click', () => this.change(item.key, item.quantity - 1, index, 'decrease'));
          const amount = this.element('output', '', String(item.quantity));
          amount.setAttribute('aria-label', this.dataset.quantity);
          const increase = this.element('button', '', '+');
          increase.type = 'button';
          increase.dataset.cartMutation = '';
          increase.dataset.cartAction = 'increase';
          increase.setAttribute('aria-label', this.dataset.increase);
          increase.addEventListener('click', () => this.change(item.key, item.quantity + 1, index, 'increase'));
          quantity.append(decrease, amount, increase);
          const remove = this.element('button', 'shadow-cart__remove', this.dataset.remove);
          remove.type = 'button';
          remove.dataset.cartMutation = '';
          remove.dataset.cartAction = 'remove';
          remove.setAttribute('aria-label', this.dataset.remove + ': ' + (item.product_title || item.title));
          remove.addEventListener('click', () => this.change(item.key, 0, index, 'remove'));
          controls.append(quantity, remove);
          content.append(controls);
          row.append(picture, content);
          this.items.append(row);
        });
        this.querySelector('[data-cart-empty]').hidden = cart.item_count > 0;
        this.querySelector('[data-cart-footer]').hidden = cart.item_count === 0;
        this.querySelector('[data-cart-total]').textContent = this.money(cart.total_price);
        const discounts = this.querySelector('[data-cart-discounts]');
        discounts.replaceChildren();
        (cart.cart_level_discount_applications || []).forEach(discount => {
          const row = this.element('p');
          row.append(this.element('span', '', discount.title), this.element('span', '', '−' + this.money(discount.total_allocated_amount)));
          discounts.append(row);
        });
        document.querySelectorAll('[data-shadow-cart-count]').forEach(element => { element.textContent = String(cart.item_count); });
        document.dispatchEvent(new CustomEvent('shadow:cart-updated', { detail: { cart } }));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shadow-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const configNode = root.querySelector('[data-product-config]');
      if (!configNode) return;
      const config = JSON.parse(configNode.textContent);
      const form = root.querySelector('.shadow-product__form');
      const addButton = root.querySelector('[data-product-add]');
      const addLabel = root.querySelector('[data-add-label]');
      const sticky = root.querySelector('[data-sticky-product]');
      const stickyButton = root.querySelector('[data-sticky-add]');
      const firstPicker = root.querySelector('[data-picker="first"]');
      const secondPicker = root.querySelector('[data-picker="second"]');
      const error = root.querySelector('[data-product-error]');
      const gallery = root.querySelector('[data-gallery]');
      const slides = Array.from(root.querySelectorAll('.shadow-product__slide'));
      const thumbnails = Array.from(root.querySelectorAll('[data-thumbnail]'));
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let bundleCount = 1;
      let busy = false;
      let currentSlide = 0;
      let addAbove = false;
      let footerVisible = false;
      let drawerOpen = false;
      let shadowCartQuantity = Number(config.shadow_cart_quantity) || 0;
      let firstVariant = config.variants.find(variant => variant.id === config.selected_id);
      let secondVariant = firstVariant;
      const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', {style: 'currency', currency: config.currency});
      const money = value => formatter.format(value / 100);
      const pickSize = picker => picker.querySelector('[data-size-choice]:checked')?.value || '';
      const sizesChosen = () => Boolean(pickSize(firstPicker) && (bundleCount !== 2 || pickSize(secondPicker)));
      const pickVariant = picker => {
        const groups = Array.from(picker.querySelectorAll('[data-option-index]'));
        if (!groups.length) return config.variants.find(variant => variant.id === config.selected_id) || config.variants[0];
        const options = groups.map(group => group.querySelector('input:checked')?.value);
        return config.variants.find(variant => variant.options.every((value, index) => value === options[index]));
      };
      const setGallery = index => {
        if (!slides.length) return;
        const bounded = Math.max(0, Math.min(index, slides.length - 1));
        gallery.scrollTo({left: slides[bounded].offsetLeft - slides[0].offsetLeft, behavior: reduceMotion ? 'instant' : 'smooth'});
      };
      const markGallery = index => {
        currentSlide = index;
        thumbnails.forEach((thumb, at) => thumb.setAttribute('aria-pressed', at === index ? 'true' : 'false'));
        const counter = root.querySelector('[data-gallery-counter]');
        if (counter) counter.textContent = `${index + 1} / ${slides.length}`;
      };
      root.querySelector('[data-gallery-controls]')?.removeAttribute('hidden');
      root.querySelector('[data-thumbnails]')?.removeAttribute('hidden');
      root.querySelector('[data-bundle-options]')?.removeAttribute('hidden');
      root.querySelector('[data-variant-pickers]')?.removeAttribute('hidden');
      addButton.removeAttribute('hidden');
      root.querySelector('[data-bundle-options]')?.after(secondPicker);
      thumbnails.forEach(thumb => thumb.addEventListener('click', () => setGallery(Number(thumb.dataset.thumbnail))));
      root.querySelector('[data-gallery-previous]')?.addEventListener('click', () => setGallery(currentSlide === 0 ? slides.length - 1 : currentSlide - 1));
      root.querySelector('[data-gallery-next]')?.addEventListener('click', () => setGallery(currentSlide === slides.length - 1 ? 0 : currentSlide + 1));
      gallery?.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          setGallery(currentSlide + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
      if ('IntersectionObserver' in window && gallery) {
        const mediaObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting && entry.intersectionRatio >= .6) markGallery(slides.indexOf(entry.target));
          });
        }, {root: gallery, threshold: .6});
        slides.forEach(slide => mediaObserver.observe(slide));
      } else if (gallery) {
        gallery.addEventListener('scroll', () => markGallery(Math.round(gallery.scrollLeft / gallery.clientWidth)), {passive: true});
      }
      const updateSticky = () => {
        sticky.hidden = !addAbove || footerVisible || drawerOpen || busy;
      };
      const canBuy = () => {
        if (!firstVariant?.available) return false;
        if (bundleCount !== 2) return true;
        if (!secondVariant?.available) return false;
        if (firstVariant.id === secondVariant.id && firstVariant.inventory_management && firstVariant.inventory_policy !== 'continue' && firstVariant.inventory_quantity < 2) return false;
        return true;
      };
      const pairTotal = () => {
        const gross = firstVariant.price + secondVariant.price;
        if (shadowCartQuantity > 0) return gross;
        return gross - Math.floor(Math.min(firstVariant.price, secondVariant.price) * 20 / 100);
      };
      const chosenTotal = () => {
        if (!firstVariant) return 0;
        if (bundleCount !== 2 || !secondVariant) return firstVariant.price;
        return pairTotal();
      };
      const update = (changeImage = false, changeUrl = false) => {
        firstVariant = pickVariant(firstPicker);
        secondVariant = pickVariant(secondPicker);
        root.querySelectorAll('[data-option-index]').forEach(group => {
          group.querySelector('[data-option-value]').textContent = group.querySelector('input:checked')?.value || '';
        });
        secondPicker.hidden = bundleCount !== 2;
        [firstPicker, secondPicker].forEach((picker, index) => {
          picker.querySelectorAll('[data-size-choice]').forEach(input => { input.disabled = index === 1 && bundleCount !== 2; });
          picker.querySelector('[data-size-value]').textContent = pickSize(picker);
          picker.querySelector('[data-size-hint]').hidden = Boolean(pickSize(picker));
        });
        const available = canBuy();
        let label = bundleCount === 2 ? config.messages.add_two : config.messages.add;
        if (!firstVariant || bundleCount === 2 && !secondVariant) label = config.messages.unavailable;
        else if (!available) label = bundleCount === 2 && firstVariant.available && secondVariant?.available ? config.messages.not_enough : config.messages.sold_out;
        else if (!sizesChosen()) label = bundleCount === 2 && pickSize(firstPicker) ? config.messages.choose_second_size : config.messages.choose_size;
        addButton.disabled = !available || !sizesChosen() || busy;
        stickyButton.disabled = !available || busy;
        addLabel.textContent = busy ? config.messages.adding : label;
        stickyButton.textContent = busy ? config.messages.adding : label;
        const hiddenId = root.querySelector('[data-variant-id]');
        hiddenId.disabled = !firstVariant;
        hiddenId.value = firstVariant?.id || '';
        if (firstVariant) {
          root.querySelector('[data-variant-price]').textContent = money(firstVariant.price);
          root.querySelector('[data-single-price]')?.replaceChildren(document.createTextNode(money(firstVariant.price)));
          root.querySelector('[data-sticky-price]').textContent = money(chosenTotal());
          root.querySelector('[data-sticky-variant]').textContent = [firstVariant.title, pickSize(firstPicker)].filter(Boolean).join(' · ');
          if (changeImage && firstVariant.media_id) {
            const mediaIndex = slides.findIndex(slide => Number(slide.dataset.mediaId) === firstVariant.media_id);
            if (mediaIndex !== -1) setGallery(mediaIndex);
          }
          if (changeUrl && root.dataset.productPage === 'true') {
            const url = new URL(window.location.href);
            url.searchParams.set('variant', firstVariant.id);
            window.history.replaceState({}, '', url);
          }
        } else {
          root.querySelector('[data-variant-price]').textContent = config.messages.unavailable;
          root.querySelector('[data-single-price]')?.replaceChildren(document.createTextNode(config.messages.unavailable));
          root.querySelector('[data-sticky-price]').textContent = config.messages.unavailable;
          root.querySelector('[data-sticky-variant]').textContent = config.messages.unavailable;
        }
        const bundlePrice = root.querySelector('[data-bundle-price]');
        if (bundlePrice) bundlePrice.textContent = firstVariant && secondVariant ? money(pairTotal()) : config.messages.unavailable;
        const bundleBadge = root.querySelector('[data-bundle-badge]');
        if (bundleBadge) bundleBadge.textContent = shadowCartQuantity > 0 ? config.messages.discount_in_bag : config.messages.second_discount;
        if (bundleCount === 2 && !secondVariant) root.querySelector('[data-sticky-price]').textContent = config.messages.unavailable;
        const stockMessage = root.querySelector('[data-stock-message]');
        const lowStock = firstVariant?.available && firstVariant.inventory_management && firstVariant.inventory_policy !== 'continue' && firstVariant.inventory_quantity > 0 && firstVariant.inventory_quantity <= 5;
        stockMessage.hidden = !lowStock;
        stockMessage.textContent = lowStock ? config.messages.low_stock.replace('__COUNT__', firstVariant.inventory_quantity) : '';
        updateSticky();
      };
      form.addEventListener('change', event => {
        error.hidden = true;
        if (event.target.name === 'shadow_bundle') bundleCount = Number(event.target.value);
        update(event.target.closest('[data-picker="first"] [data-option-index]') !== null, true);
      });
      form.addEventListener('submit', async event => {
        if (!window.ShadowCart?.add) {
          if (bundleCount === 1 && canBuy() && sizesChosen()) return;
          event.preventDefault();
          error.textContent = config.messages.add_error;
          error.hidden = false;
          error.focus();
          return;
        }
        event.preventDefault();
        if (busy || !canBuy() || !sizesChosen()) return;
        const items = [{id: firstVariant.id, quantity: 1, properties: {Size: pickSize(firstPicker)}}];
        if (bundleCount === 2) {
          if (firstVariant.id === secondVariant.id && pickSize(firstPicker) === pickSize(secondPicker)) items[0].quantity = 2;
          else items.push({id: secondVariant.id, quantity: 1, properties: {Size: pickSize(secondPicker)}});
        }
        busy = true;
        error.hidden = true;
        form.setAttribute('aria-busy', 'true');
        update();
        try {
          await window.ShadowCart.add(items, addButton);
        } catch (failure) {
          error.textContent = failure?.message || config.messages.add_error;
          error.hidden = false;
          error.focus();
        } finally {
          busy = false;
          form.removeAttribute('aria-busy');
          update();
        }
      });
      stickyButton.addEventListener('click', () => {
        if (!sizesChosen()) {
          const picker = pickSize(firstPicker) ? secondPicker : firstPicker;
          picker.querySelector('[data-size-picker]').scrollIntoView({behavior: reduceMotion ? 'instant' : 'smooth', block: 'center'});
          picker.querySelector('[data-size-choice]')?.focus({preventScroll: true});
          return;
        }
        form.requestSubmit(addButton);
      });
      document.addEventListener('shadow:cart-state', event => { drawerOpen = Boolean(event.detail?.open); updateSticky(); });
      document.addEventListener('shadow:cart-updated', event => {
        const items = event.detail?.cart?.items;
        if (!Array.isArray(items)) return;
        shadowCartQuantity = items.reduce((quantity, item) => String(item.product_id) === String(config.product_id) ? quantity + Math.max(0, Number(item.quantity) || 0) : quantity, 0);
        update();
      });
      if ('IntersectionObserver' in window) {
        const buttonObserver = new IntersectionObserver(entries => {
          addAbove = !entries[0].isIntersecting && entries[0].boundingClientRect.bottom < 0;
          updateSticky();
        });
        buttonObserver.observe(addButton);
        const footer = document.querySelector('footer');
        if (footer) {
          const footerObserver = new IntersectionObserver(entries => {footerVisible = entries[0].isIntersecting; updateSticky();});
          footerObserver.observe(footer);
        }
      }
      window.ShadowProduct = {
        selectColor: color => {
          const fieldset = firstPicker.querySelector('[data-option-color="true"]');
          const radios = Array.from(fieldset?.querySelectorAll('input') || []);
          const stableColors = {black: 0, charcoal: 1, white: 2, red: 3};
          const colorKey = color.toLowerCase();
          const radio = radios.find(input => input.value.toLowerCase() === colorKey) || radios[stableColors[colorKey]];
          if (!radio) return;
          radio.checked = true;
          update(true, true);
          root.scrollIntoView({behavior: reduceMotion ? 'instant' : 'smooth', block: 'start'});
        }
      };
      update(true);
    };
    const mount = () => document.querySelectorAll('[data-shadow-product]').forEach(initialize);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
    else mount();
    document.addEventListener('shopify:section:load', mount);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shadow-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mount = () => document.querySelectorAll('[data-shadow-reviews]').forEach(root => {
      if (root.dataset.reviewsReady) return;
      root.dataset.reviewsReady = 'true';
      const track = root.querySelector('[data-review-track]');
      const cards = Array.from(root.querySelectorAll('[data-review-card]'));
      const controls = root.querySelector('[data-review-controls]');
      const previous = root.querySelector('[data-review-previous]');
      const next = root.querySelector('[data-review-next]');
      if (!track || !cards.length) return;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const isRtl = getComputedStyle(track).direction === 'rtl';
      const update = () => {
        const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
        const position = Math.abs(track.scrollLeft);
        controls.hidden = maximum < 3;
        previous.disabled = position < 3;
        next.disabled = position >= maximum - 3;
      };
      const step = direction => {
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        const distance = cards[0].getBoundingClientRect().width + gap;
        track.scrollBy({left: distance * direction * (isRtl ? -1 : 1), behavior: reducedMotion.matches ? 'instant' : 'smooth'});
      };
      previous.addEventListener('click', () => step(-1));
      next.addEventListener('click', () => step(1));
      track.addEventListener('scroll', update, {passive: true});
      track.addEventListener('keydown', event => {
        if (event.target !== track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        step(direction * (isRtl ? -1 : 1));
      });
      if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(update);
        observer.observe(track);
      }
      update();
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
    else mount();
    document.addEventListener('shopify:section:load', mount);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shadow-story"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',event=>{const link=event.target.closest('[data-shadow-color]');if(link&&window.ShadowProduct?.selectColor){window.ShadowProduct.selectColor(link.dataset.shadowColor);}});

  } catch(e) { console.error(e); }
})();
})();
